<script>
export default {
  name: 'MzRouterView',
}
</script>

<template>
  <router-view />
</template>

<style scoped>

</style>
